export const IsDevelopment = process.env.NODE_ENV === 'development';
export const APIUrl = IsDevelopment ? 'http://localhost:5555/' : '../api/';
export const AuthUrl = IsDevelopment ? 'http://localhost:5555/' : '../api/';

export const defaultDateFormat = 'dd/MM/yyyy';

export const SVMMinimumDateString = '0001-01-01T00:00:00';
export const SVMDateFormat = 'DD/MM/YYYY';

export const errorTypes = {
    Fatal: 0,
    Unauthorized: 1,
    Validation: 2
};

export const httpStatus = {
    Ok: 200,
    Forbidden: 403
};

export const ErrorData = {
    errorType: errorTypes.Fatal,
    message: '',
    guidId: '',
    statusCode: httpStatus.Ok,
    stackTrace: ''
};

export const HostNames = {
    Silvermouse: 'silvermouse',
    Soundmouse: 'soundmouse'
};



// WEBPACK FOOTER //
// ./src/constants.js